// this comment tells babel to convert jsx to calls to a function called jsx instead of React.createElement
/** @jsx jsx */
import { css, jsx } from "@emotion/react"
import { COLORS, FONTWEIGHT, FONTSIZE } from "../../utils/styles"

export const HEADER_HEIGHT = 60

const container = css`
  height: ${HEADER_HEIGHT}px;
  border: 0px solid ${COLORS.CEDEDED};
  border-bottom-width: 1px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  @media (max-width: 500px) {
    padding: 0 16px;
  }
`
const heading = css`
  color: ${COLORS.C3E51B5};
  font-weight: ${FONTWEIGHT.REGULAR};
  font-size: ${FONTSIZE.F16};
  margin-left: 48px;
  outline: none;
  text-decoration: none;
  cursor: pointer;
  @media (max-width: 500px) {
    margin-left: 0;
  }
`

const headingContainer = css`
  display: flex;
  flex-direction: row;
`

const gzpLogo = css`
  width: 142px;
  @media (max-width: 500px) {
    width: 80px;
  }
`

export { container, heading, headingContainer, gzpLogo }
